import { render, staticRenderFns } from "./ProjectsCarousel.vue?vue&type=template&id=2856b4e2"
import script from "./ProjectsCarousel.vue?vue&type=script&lang=js"
export * from "./ProjectsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports